import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectPictureOrigin } from 'redux/selector/app'
import { fetchBinFile } from 'api'
import { Wrapper, Icon, Name } from './Styled'
import { useAdLinkHandler } from 'hooks/useAdLinkHandler'
import type { SchemaOholoMaterialShow } from 'api/generated'
/**
 * @typedef {import("api/generated").SchemaOholoMaterialShow & { pageUuid?: string }} DataItemLink
 */

interface ItemLinkProps extends SchemaOholoMaterialShow {
  pageUuid?: string
}

export default function ItemLink({ pageUuid, ...link }: ItemLinkProps) {
  const pictureOrigin = useSelector(selectPictureOrigin)
  const [base64Img, setBase64Img] = useState('')

  const handleAdLink = useAdLinkHandler()

  useEffect(() => {
    if (!pictureOrigin || !link.icon_path) return

    const controller = new AbortController()
    const shortcutImagePath = `${pictureOrigin}/${link.icon_path}`

    fetchBinFile({
      url: shortcutImagePath,
      signal: controller.signal,
    }).then((textBase64: any) => setBase64Img(textBase64))
  }, [pictureOrigin, link.icon_path])

  const handleRedirect = () => {
    handleAdLink({
      link,
      pageUuid,
    })
  }

  return (
    <Wrapper onClick={handleRedirect}>
      <Icon base64Img={base64Img} />
      <Name>{link.name}</Name>
    </Wrapper>
  )
}
